module.exports = __webpack_public_path__ + "img/kn_get.cbbcde6.png";